import MultipleQRCodeScannerView from './MultipleQRcodeScannerView';

export * from './camera.helper';
export default MultipleQRCodeScannerView;
